// import ConnectWallet from "./ConnectWallet";

import { useState } from "react";
import Web3 from 'web3'


const ConnectAddressCard = ({ onValidAddressChange }) => {
    const [validity, setValidity] = useState(false);
    const [address, setAddress] = useState("");
    var web3 = new Web3('https://mainnet.infura.io/v3/' + process.env.REACT_APP_INFURA_KEY);

    const addressChanged = (text) => {
        const typed = text.target.value.trim();
        setAddress(typed);
        if (typed.substring(typed.length - 4) === ".eth") {

            // support ENS domains
            web3.eth.ens.getAddress(typed).then(function (address) {
                onValidAddressChange(address);
                setValidity(true);
                setAddress(typed);
            }).catch(() => {
                setValidity(false);
            })
        } else {

            // hex addresses
            if (web3.utils.isAddress(typed)) {
                onValidAddressChange(typed);
                setValidity(true);
            } else {
                setValidity(false);
            }
        }
    }

    const toEtherscan = () => {
        if (validity) {
            window.open("https://etherscan.io/address/" + address);
        }
    }

    return (
        <div className="card">
            {/* First, connect your Metamask wallet.<br></br>
            <ConnectWallet text="Connect Metamask" /><br></br><br></br> */}
            Enter an Ethereum wallet address.<br></br>
            <input className="ethAddressInput" placeholder="0x... or .eth domain" onChange={addressChanged}></input><br></br>
            {address && <div className="connected">{validity ? "valid" : "invalid"} address: <span className={(validity ? "valid" : "invalid") + "Address"} onClick={toEtherscan}>{address}</span></div>}

        </div >
    );
}

export default ConnectAddressCard;